// removed by extract-text-webpack-plugin
module.exports = {"formContainer":"requestPassword__formContainer--1PNw-","headingContainer":"requestPassword__headingContainer--1o8kg","heading":"requestPassword__heading--1qVJ5","link":"requestPassword__link--nyrgX"};


//////////////////
// WEBPACK FOOTER
// ./src/app/views/PasswordRequest/requestPassword.css
// module id = 79/d
// module chunks = 40